import { Pipe, PipeTransform } from '@angular/core';
import { PurchaseOrderInvoiceLabel } from '../models/purchase-order/purchase-order-invoice-status.model';

@Pipe({
  name: 'invoiceStatus',
  standalone: false,
})
export class PurchaseOrderInvoiceLabelPipe implements PipeTransform {
  private static readonly LABEL_MAP: Readonly<Record<PurchaseOrderInvoiceLabel, string>> = {
    [PurchaseOrderInvoiceLabel.REMOVED_FROM_FISCAL_PANEL]: 'Removido do Painel Fiscal',
    [PurchaseOrderInvoiceLabel.SENT_WITHOUT_INVOICE]: 'Enviado sem nota',
    [PurchaseOrderInvoiceLabel.MANUALLY_ASSOCIATED]: 'Associado manualmente',
    [PurchaseOrderInvoiceLabel.AUTOMATICALLY_ASSOCIATED]: 'Associado automaticamente',
    [PurchaseOrderInvoiceLabel.PRIOR_TO_DEMAND]: 'Associação indisponível',
    [PurchaseOrderInvoiceLabel.NOT_ASSOCIATED]: '-',
  } as const;

  private static readonly DEFAULT_LABEL = '-';

  transform(value: PurchaseOrderInvoiceLabel): string {
    return PurchaseOrderInvoiceLabelPipe.LABEL_MAP[value] ?? PurchaseOrderInvoiceLabelPipe.DEFAULT_LABEL;
  }
}
